import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
// import Circular from './Circularprogress';
// import Modalopener from './Modal.jsx';
// import Menuname from './Supplymenu.jsx';
import Search from '@mui/icons-material/Search';
import Nodata from '../pages/nodatafound.jsx';

import Circular from '../components/Circularprogress';
import Modalopener from '../modal/Modal.jsx';
import Menuname from '../components/Supplymenu1.jsx';
import Modalviewer from '../modal/Modalview.jsx';
import Modalediter from '../modal/Modaledit.jsx';
import Modaldelete from '../modal/Modaldelete.jsx';
import Modalpermission from '../modal/Modalpermission.jsx';
import Modalpassword from '../modal/Modalpassword.jsx';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin';
import { getstaff } from '../redux/staff';
import { getagent } from '../redux/agent';

import { Modal } from '@mui/material';

function createData(
  id,
  image,
  surname,
  othername,
  lastname,
  contact,
  idnumber,
  ssnit,
  gender,
  dob,
  license,
  expiry,
  dateemployed,
  iniposition,
  position,
  employmenttype,
  marrital,
  assetusage,
  others,
permissions) {
  return {
id,image,surname,othername,lastname,contact,idnumber,ssnit,gender,dob,license,expiry,dateemployed,iniposition,position,employmenttype,marrital,assetusage,others, permissions };
}

var rows = [
  createData(1, 'Cupcake', 305, 3.7, 67, 4.3),
  createData(2, 'Donut', 452, 25.0, 51, 4.9),
  createData(3, 'Eclair', 262, 16.0, 24, 6.0),
  createData(4, 'Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData(5, 'Gingerbread', 356, 16.0, 49, 3.9),
  createData(6, 'Honeycomb', 408, 3.2, 87, 6.5),
  createData(7, 'Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData(8, 'Jelly Bean', 375, 0.0, 94, 0.0),
  createData(9, 'KitKat', 518, 26.0, 65, 7.0),
  createData(10, 'Lollipop', 392, 0.2, 98, 0.0),
  createData(11, 'Marshmallow', 318, 0, 81, 2.0),
  createData(12, 'Nougat', 360, 19.0, 9, 37.0),
  createData(13, 'Oreo', 437, 18.0, 63, 4.0),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Name',
  },
  {
    id: 'contact',
    numeric: false,
    disablePadding: false,
    label: 'Contact',
  },  {
    id: 'gender',
    numeric: false,
    disablePadding: false,
    label: 'Gender',
  },
  {
    id: 'address',
    numeric: false,
    disablePadding: false,
    label: 'Address',
  },
  {
    id: 'Position',
    numeric: false,
    disablePadding: false,
    label: 'Position',
  },
  {
    id: 'DOB',
    numeric: false,
    disablePadding: false,
    label: 'DOB',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
      <TableCell
          
            align="left"
            padding='normal'
            
          >
            NO.
            </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EnhancedTable() {
  
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)
  const agent = useSelector((state) => state.agent)
  var rows_ = [(agent || []).map((list, index) => createData(list._id, list.image, list.surname, list.othername, list.lastname, list.contact, list.idnumber, list.ssnit, list.gender, list.dob, list.license, list.expiry, list.dateemployed, list.iniposition, list.position, list.employmenttype, list.marrital, list.assetusage, list.others, list.permissions))]
  const [rows, setRows] = React.useState(rows_.length === 1 ? rows_[0] : [])

  const [order, setOrder] = React.useState('asc');
  const [Modalvalue, setModalvalue] = React.useState(false);
  const [Modalview, setModalview] = React.useState(false);
  const [Modaldeleter, setModaldeleter] = React.useState(false);
  const [Modalpermissioner, setModalpermissioner] = React.useState(false);
  const [Modalresetpassworder, setModalresetpassworder] = React.useState(false);
  const [Modaledit, setModaledit] = React.useState(false);
  const [Chosen, setChosen] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [search, setSearch] = React.useState("");

  // Add error handling for data fetching
  React.useEffect(() => {
    try {
      if (!rows) {
        setRows([]); // Ensure rows is never undefined
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setRows([]); // Set empty array on error
    }
  }, []);

  // Memoized search function
  const searching = React.useCallback((e) => {
    setSearch(e.target.value);
    setPage(0); // Reset to first page when searching
  }, []);

  // Memoized filtered rows
  const filteredRows = React.useMemo(() => {
    if (!search) return rows;
    
    const searchLower = search.toLowerCase();
    return rows.filter(row => 
      Object.values(row).some(value => 
        value && 
        typeof value === 'string' && 
        value.toLowerCase().includes(searchLower)
      )
    );
  }, [search, rows]);

  // Memoized visible rows with sorting and pagination
  const visibleRows = React.useMemo(() => {
    if (!filteredRows) return []; // Add null check
    const sortedRows = [...filteredRows].sort(getComparator(order, orderBy));
    return sortedRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filteredRows, order, orderBy, page, rowsPerPage]);

  // Memoized empty rows calculation
  const emptyRows = React.useMemo(() => {
    return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;
  }, [page, rowsPerPage, filteredRows.length]);

  // Update rows when data changes
  React.useEffect(() => {
    if (search !== "") {
      const listed = rows_.length === 1 ? rows_[0].filter(item => 
        (item.surname && item.surname.toLowerCase().includes(search.toLowerCase())) ||
        (item.othername && item.othername.toLowerCase().includes(search.toLowerCase())) ||
        (item.lastname && item.lastname.toLowerCase().includes(search.toLowerCase())) ||
        (item.contact && item.contact.toLowerCase().includes(search.toLowerCase())) ||
        (item.idnumber && item.idnumber.toLowerCase().includes(search.toLowerCase())) ||
        (item.gender && item.gender.toLowerCase().includes(search.toLowerCase())) ||
        (item.position && item.position.toLowerCase().includes(search.toLowerCase()))
      ) : [];
      setRows(listed);
    } else {
      setRows(rows_.length === 1 ? rows_[0] : []);
    }
  }, [search, agent, rows_]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const showdata=(event, data)=>{
   
   
    setModalvalue(true)
 
      
    setChosen(data)

   
  }

  const setoff=()=>{
    setModalvalue(false)
    setModaldeleter(false)
    setModaledit(false)
    setModalpermissioner(false)

  }
  const setoffer=()=>{
    setModalview(false)
    setModaldeleter(false)
    setModaledit(false)
    setModalpermissioner(false)
    setModalresetpassworder(false)
  }

  
  const setview=()=>{
    console.log("clicked")
    setModalview(true)
    
  } 
  
  const setpermission=()=>{
    console.log("clicked")
    setModalpermissioner(true)
  }
 
  const setresetpassword=()=>{
    setModalresetpassworder(true)
  }

  const setdeleter=()=>{
    console.log("clicked delete")
    setModaldeleter(true)
  }

  const setedit=()=>{

    setModaledit(true)
  }

  return(
    <Box sx={{ width: '100%'}}>

    {Modalvalue===true && <Modalopener  value={Modalvalue} chosen={Chosen} product={Chosen.name} setfalse={setoff} name="agent"  Menu={<Menuname  name="agent" chosen={Chosen} value={Modalview} permission={setpermission} resetpassword={setresetpassword} view={setview} delete={setdeleter} edit={setedit} product={Chosen.name}  />}/>  }
    {Modalview===true &&  <Modalviewer 
      name="agent"  
      product={Chosen.surname + ' ' + Chosen.othername + ' ' + Chosen.lastname}
      chosen={Chosen}
      view={setview}
      setfalser={setoffer}
      value={Modalvalue}
      details={{
        'Full Name': (Chosen.surname || '') + ' ' + (Chosen.othername || '') + ' ' + (Chosen.lastname || ''),
        'Contact': Chosen.contact || 'No Contact',
        'Gender': Chosen.gender || 'No Gender',
        'Address': Chosen.address || 'No Address',
        'ID Number': Chosen.idnumber || 'No ID Number',
        'SSNIT': Chosen.ssnit || 'No SSNIT',
        'Date of Birth': Chosen.dob || 'No Date of Birth',
        'License': Chosen.license || 'No License',
        'License Expiry': Chosen.expiry || 'No Expiry',
        'Date Employed': Chosen.dateemployed || 'No Date Employed',
        'Initial Position': Chosen.iniposition || 'No Initial Position',
        'Current Position': Chosen.position || 'No Position',
        'Employment Type': Chosen.employmenttype || 'No Employment Type',
        'Marital Status': Chosen.marrital || 'No Marital Status',
        'Asset Usage': Chosen.assetusage || 'No Asset Usage',
        'Other Info': Chosen.others || 'No Additional Information',
        'Permissions': Chosen.permissions || 'No Permissions'
      }}
    />}
    {Modaldeleter===true && <Modaldelete name="agent" delete={"agent"} dispatcher={getagent}   product={Chosen.name} chosen={Chosen}  view={setdeleter} setfalser={setoffer} value={Modaldeleter}/>}
    {Modaledit===true &&  <Modalediter name="Agent" product={Chosen.name} chosen={Chosen}  view={setedit} setfalser={setoffer} value={Modaledit}/>}
    {Modalpermissioner===true &&  <Modalpermission name="agent" link="https://server.agrotraciserp.com/api/agent/editagent/" product={Chosen.name} chosen={Chosen}  view={setedit} setfalser={setoffer} value={Modalpermissioner}/>}
    {Modalresetpassworder===true &&  <Modalpassword name="agent"  product={Chosen.name} chosen={Chosen}  view={setedit} setfalser={setoffer} value={Modalresetpassworder}/>}

    <Paper sx={{ width: '100%', mb: 2 }}>

        <TableContainer>
      
        <div style={{padding:"10px"}}>

    <Grid container>
                    <Grid lg={4} xs={2} md={6}>
              
                    </Grid>
                  
                    <Grid lg={4} xs={2} md={6} style={{textAlign:"center"}}>
                      
    <div style={{position:"relative"}}> 
                    <Search id="searchbox"  style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color:"grey" }} /> <input type="search" onChange={(e) => searching(e)} placeholder="Search" style={{ padding: 10, paddingLeft: "38px", marginTop: 10, width: "100%", border: "solid", borderRadius: "5px", borderWidth: "0.5px", backgroundColor: "rgba(65,105,225, 0.05) ", borderColor: "#2196f3" }} />
                    </div> 

                    </Grid>

                    <Grid lg={4} xs={10} md={6}>
                    </Grid>

                    
                </Grid>

</div>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
            {(visibleRows || []).map((row, index) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event)=>showdata(event, row)}
                    role="checkbox"
                    // aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="normal">
                      
                      {(rowsPerPage*page)+index+1}

                    </TableCell>
                    <TableCell
                    
                      // component="th"
                      id={labelId}
                      scope="row"
                      // padding="normal"
                    >
                      {row.surname +" "+row.othername+" "+row.lastname}
                    </TableCell>
                    <TableCell align="left">{row.contact}</TableCell>
                    <TableCell align="left">{row.gender}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    <TableCell align="left">{row.position}</TableCell>
                    <TableCell align="left">{row.dob}</TableCell>
                  </TableRow>
                );
              })}

              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        
        {rows.length===0 && <Nodata/>}
          
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[30, 40, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
}
